// extracted by mini-css-extract-plugin
export default {"btn":"User_btn__LQrNC","wrapper":"User_wrapper__4GlKL"};